import { Injectable } from '@angular/core';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const USER_DETAILS = 'user-details';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor() { }

  signOut(): void {
    window.localStorage.clear();
  }

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return window.localStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user: any): void {
    user.isAuthenticated = true;
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public getRole(): any {
    const userString = window.localStorage.getItem(USER_KEY);
    if (!userString) return [];
    const user = JSON.parse(userString);
    return user.roles || [];
  }

  isAuthenticated() {
    let user = this.getUser()
    return user && user.isAuthenticated ? true : false;
  }

  public saveUserDetails(user: any): void {
    window.localStorage.removeItem(USER_DETAILS);
    window.localStorage.setItem(USER_DETAILS, JSON.stringify(user));
  }

  public getUserDetails(): any {
    const user = window.localStorage.getItem(USER_DETAILS);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }


}
